import { Route, Routes } from 'react-router-dom';

import Unit from './don-vi-tinh';
import Product from './hang-hoa-dich-vu';
import PartnerService from './doi-tac';
import Device from './thiet-bi';
import TenantClient from './khach-hang';
import EmailTemplate from './mau-email';
import Tax from './thue-suat';
import Currency from './tien-te';
import PaymentType from './ht-thanh-toan';
import { PrivateRoute } from '../components/PrivateRoute';
import StoreService from './cua-hang-xang-dau';
import { ROLE } from '../../Constant';
import NhomSanPham from './nhom-san-pham';
import BangGiaVang from './bang-gia-vang';

export default function Category() {

  return (
    <Routes>
      <Route path="don-vi-tinh/*" element={
        <Unit />
      }
      />
      <Route path="hang-hoa-dich-vu/*" element={<Product />} />
      {/* <Route path="hang-hoa-xang-dau/*" element={<Petrolimex/>}/> */}
      {/* <Route path="thiet-bi/*" element={<Device/>}/> */}
      <Route path="khach-hang/*" element={<TenantClient />} />
      <Route path='nhom-san-pham/*' element={<NhomSanPham />} />
      <Route path='bang-gia-vang/*' element={<BangGiaVang />} />

      {/* <Route path="mau-email/*" element={<EmailTemplate/>}/> */}
      <Route path="thue-suat/*" element={<Tax />} />
      <Route path="tien-te/*" element={<Currency />} />
      <Route path="doi-tac/*" element={<PartnerService />} />
      <Route path="ht-thanh-toan/*" element={<PaymentType />} />
      {/* <Route path="danh-sach-giao-dich-xang-dau/*" element={<PetrolimexLog/>}/>
      <Route path="cua-hang-xang-dau/*" element={<StoreService/>}/> */}
    </Routes>
  );
}
